import { Icon } from 'components/Icon/Icon';
import { Text } from 'components/Text/Text';

export function ListingViewHeaderDoneInADayTag() {
  return (
    <Text display="inline-block" color="brightPlum">
      <Icon name="hammer" size={18} /> {getText('Done in a Day')}
    </Text>
  );
}
